(function () {
    "use strict";

    // Dark mode switcher
    $(".dark-mode-switcher").on("click", function () {
        let html_ele = $('html');
        if (html_ele.hasClass('light')) {
            html_ele.removeClass('light');
            html_ele.addClass('dark');
            postAjax('/api/dark_mode', {dark_mode: 1}, () => {
            });
        } else {
            html_ele.removeClass('dark');
            html_ele.addClass('light');

            postAjax('/api/dark_mode', {dark_mode: 0}, () => {
            });
        }

    });


    function postAjax(url, data, success) {
        var params = typeof data == 'string' ? data : Object.keys(data).map(
            function (k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
            }
        ).join('&');

        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
        xhr.open('POST', url);
        xhr.onreadystatechange = function () {
            if (xhr.readyState > 3 && xhr.status === 200) {
                success(xhr.responseText);
            }
        };
        xhr.setRequestHeader('X-CSRFToken', document.getElementsByName('csrfmiddlewaretoken')[0].value);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(params);
        return xhr;
    }
})();
